import {API_V1} from "../config/main-axios";

class Reports {
  getCountries() {
    return API_V1.get(`/locations/country/`)
  }

  getTeachers() {
    return API_V1.get(`/accounts/admin/users/?is_teacher=true`)
  }

  getUsersList(data) {
    return API_V1.get(`/reports/admin/users/`, {
      params: data
    })
  }

  getUsersLeftList(data) {
    return API_V1.get(`/reports/admin/users/student_with_status/?status__in=LEFT%2CLEAVING`, {
      params: data
    })
  }

  getNps(data) {
    return API_V1.get(`/reports/admin/registers/last_year_nps/`, {
      params: data
    })
  }

  getUser(data) {
    return API_V1.get(`/reports/admin/registers/last_year_per_location/`, {
      params: data
    })
  }

  getUserActivity(data) {
    return API_V1.get(`/reports/admin/registers/last_year_per_activity/`, {
      params: data
    })
  }

  getTeacherClass(data) {
    return API_V1.get(`/reports/admin/registers/last_year_per_course_type/`, {
      params: data
    })
  }

  getFinancial(data) {
    return API_V1.get(`/reports/admin/registers/last_year_orders_per_location_and_course_type/`, {
      params: data
    })
  }
}

export default new Reports();
